import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import {
  PageHeaderService,
  PageHeaderState,
} from '../../services/page-header/page-header.service';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  standalone: false,
})
export class PageHeaderComponent implements AfterViewChecked {
  @ViewChild('actionsHost') actionsHost?: ElementRef<HTMLElement>;

  /** True when the projected actions template rendered at least one element. */
  hasActions = false;

  constructor(
    public pageHeader: PageHeaderService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewChecked(): void {
    // The actions template may render nothing (all its @if branches false), in
    // which case the ⋮ trigger must not appear. Inspect the live DOM.
    const host = this.actionsHost?.nativeElement;
    const has = !!host && host.querySelector('button, a, .btn') !== null;
    if (has !== this.hasActions) {
      this.hasActions = has;
      this.cdr.detectChanges();
    }
  }

  hasCounter(state: PageHeaderState): boolean {
    return state.count !== null && state.count !== undefined;
  }

  onBack(state: PageHeaderState): void {
    this.pageHeader.goBack(state);
  }
}
